import React from 'react'
import { Bill } from '../modules/bills/components/bills/Bills'
import { BankAccount } from '../modules/offramp/components/BankAccounts'
import { Body, Spacer } from '@spritz-finance/ui'
import { CircleLogo } from '../modules/bills/components/InstitutionImage'
import { Column } from './Layout/Column'
import { Row } from './Layout/Row'
import { toHumanReadableAccountType } from '../modules/offramp/utils'
import { themedImage } from '../theme/utils'
import PaySomeoneImage from '../assets/icons/pay-someone.png'
import SpritzCardImage from '../assets/icons/spritzcard.svg'
import { CheckbookVirtualCard, FullSpritzCardFragment } from '../graphql/generated/graphql'

export type FullAccount = Bill | BankAccount | FullSpritzCardFragment

export const fullAccountLogoUrl = (fa: FullAccount) => {
    if (fa.__typename === 'Bill') {
        return fa.institution?.logoUrl
    } else if (fa.__typename === 'CheckbookAccount' && !fa.ownedByUser) {
        return themedImage('paySomeone', PaySomeoneImage)
    } else if (fa.__typename === 'CheckbookAccount') {
        return fa.institution?.logo
    } else if (fa.__typename === 'CheckbookVirtualCard') {
        return themedImage('spritzCard', SpritzCardImage)
    }

    return null
}

export const fullAccountDescription = (fa: FullAccount) => {
    if (fa.__typename === 'Bill') {
        return fa.institution?.name
    } else if (fa.__typename === 'CheckbookAccount' && !fa.ownedByUser) {
        return 'Spritz Pay'
    } else if (fa.__typename === 'CheckbookAccount') {
        return toHumanReadableAccountType(fa)
    } else if (fa.__typename === 'CheckbookVirtualCard') {
        return 'Pre-funded card'
    }

    return null
}

export const fullAccountName = (fa: FullAccount) => {
    if (fa.__typename === 'CheckbookVirtualCard') {
        return `SpritzCard (....${fa.mask})`
    }

    return (fa as Bill | BankAccount).name
}

export const FullAccountSummary: React.VFC<{ fa?: FullAccount }> = ({ fa }) => {
    if (!fa) {
        return null
    }

    return (
        <Row>
            <CircleLogo size={47} logoUrl={fullAccountLogoUrl(fa)} />
            <Spacer width={8} />
            <Column>
                <Body.Med size={14} secondary>
                    {fullAccountDescription(fa)}
                </Body.Med>
                <Body.Bold size={18}>{fullAccountName(fa)}</Body.Bold>
            </Column>
        </Row>
    )
}
